<template>
  <v-card :elevation="0">
    <v-toolbar flat color="transparent">
      <v-toolbar-title>{{ this.$Amplify.I18n.get("Filters") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click.stop="addFilter">
        <v-icon left>mdi-plus</v-icon
        >{{ this.$Amplify.I18n.get("Add Filter") }}</v-btn
      >
    </v-toolbar>

    <v-alert
      v-if="alert.message"
      v-model="alert.show"
      prominent
      dense
      dismissible
      :type="alert.type || 'error'"
      transition="scale-transition"
    >
      <v-layout align-center wrap>
        <div>
          {{ alert.message }}
        </div>
      </v-layout>
    </v-alert>

    <v-alert
      prominent
      v-if="filterExcluded.length > 0"
      dismissible
      type="warning"
      color="warning"
      transition="scale-transition"
    >
      <v-layout align-center wrap>
        <div>
          Los siguientes filtros no aplican a esta vizualización:
          <strong>{{ filterExcluded.join(",") }}</strong>
        </div>
      </v-layout>
    </v-alert>

    <v-card-text class="ma-0 pa-0">
      <!-- <span v-if="filters.length > 0" class="subheading hidden-sm-and-down"> Tiene {{filters.length}} filtro{{filters.length>1?"s":""}}</span>
      <span v-else class="subheading hidden-sm-and-down"> No tiene filtros</span>  -->

      <!--       <p>{{ filterList }}</p>
      <p>{{ getRoute }}</p>
      <p>{{ filterExcluded }}</p> -->
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="filters"
        class="elevation-0"
        item-key="uuid"
        show-select
      >
        <template v-slot:header.data-table-select="{ on, props }">
          <v-simple-checkbox
            :ripple="false"
            color="primary"
            v-bind="props"
            v-on="on"
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.data-table-select="{ isSelected, select }">
          <v-simple-checkbox
            :ripple="false"
            color="primary"
            :value="isSelected"
            @input="select($event)"
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.field.label="{ item }">
          <span class="font-weight-medium">{{ item.field.label }} </span><br />
          <span class="font-weight-light">{{ item.param }}</span>
        </template>
        <template v-slot:item.options="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              :color="hover ? 'primary' : ''"
              icon
              @click.stop="editFilter(item)"
            >
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
        <template v-slot:no-data>
          No tiene filtros agregados
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions class="mx-0 px-0">
      <v-btn
        v-if="selected.length > 0"
        color="primary"
        text
        @click="deleteFilters"
        class="subtitle-2"
      >
        {{ this.$Amplify.I18n.get("Delete selected") }} [{{
          selected.length
        }}]</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn
        outlined
        color="secondary"
        @click="saveQuery"
        :disabled="filters.length < 1"
      >
        {{ this.$Amplify.I18n.get("Save Query") }}</v-btn
      >
    </v-card-actions>

    <v-alert text color="primary">
      <v-chip class="ma-2" color="primary">
        <v-icon left>
          mdi-fire
        </v-icon>
        Proximamente
      </v-chip>
      <span style="font-size:18px; font-weight: 500; ">
        Alertas y notificaciones
      </span>
      <div>
        Suscribase a notificaciones de cambios de planes de compras (inserciones
        y eliminaciones), publicaciones de procesos y adjudicaciones que le
        interesen usando filtros.
      </div>

      <v-divider class="my-4 info" style="opacity: 0.22"></v-divider>

      <v-row align="center" no-gutters>
        <v-col class="grow subtitle-2"> </v-col>
        <v-spacer></v-spacer>
        <v-col class="shrink">
          <v-btn color="primary" outlined>
            Crear Alerta
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>
  </v-card>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {},
  data() {
    return {
      headers: [
        { text: "Filtro", value: "field.label" },
        {
          text: "Opciones",
          value: "options",
          sortable: false,
          align: "center",
          width: "85"
        }
      ],
      selected: [],
      alert: {
        show: false,
        type: "",
        message: ""
      },
      error: "",
      logger: {}
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters(["filters", "filterList", "filterExcluded", "getRoute"])
  },
  methods: {
    ...mapActions([
      "deleteFiltersAction",
      "getSavedQueriesAction",
      "showAddOrEditFilterDialog",
      "showSaveQueryDialog",
      "showSelectFilterDialog"
    ]),
    addFilter: function() {
      this.showSelectFilterDialog();
    },
    editFilter: function(item) {
      this.showAddOrEditFilterDialog();
      setTimeout(() => AmplifyEventBus.$emit("edit-filter", item), 200);
    },
    deleteFilters: function() {
      this.deleteFiltersAction(this.selected);
      this.selected = [];
    },
    saveQuery: function() {
      this.showSaveQueryDialog();
    },
    setError(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.setAlert({ message: this.error });
      this.logger.error(this.error);
    },
    setAlert: function({ message = "", type = "error" }) {
      this.alert = {
        message,
        type,
        show: message.length > 1 ? true : false
      };
    }
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  }
};
</script>
